import i18n from '@/plugins/i18n';
import {
  ALL,
  CRITICAL,
  DEBUG,
  INFO,
  WARNING,
} from '@/components/AlertsV2/tag-grouping/tags.constants';

const tagsTableHeaders = () => [
  {
    name: i18n.global.t('alert.groupName'),
    key: 'groupName',
    width: '25%',
    sortable: true,
  },
  {
    name: i18n.global.t('alert.priority'),
    key: 'priority',
    width: '15%',
    sortable: true,
  },
  {
    name: i18n.global.t('alert.timeConfigured'),
    key: 'aggTime',
    width: '15%',
    sortable: true,
  },
  // { name: 'Group values', key: 'groupValues', width: '15%' },
  {
    name: i18n.global.t('alert.lastModified'),
    key: 'lastUpdatedAt',
    width: '15%',
    sortable: true,
  },
  {
    name: i18n.global.t('alert.created'),
    key: 'createdAt',
    width: '15%',
    sortable: true,
  },
  { name: i18n.global.t('alert.actionItems'), key: 'actions', width: '15%' },
];

const tagAggTimeDefault = '60';

const tagFormDefaultData = {
  tagGroupNameInfo: {
    groupName: '',
    tagId: '',
    groupingCondition: ALL,
    groupingConditions: [
      { isAnd: true, value1: '', value2: '', isValid: true },
    ],
    groupingLabeledKeyExpression: '',
    tagGroupId: '',
  },
  timeFrameInfo: {
    aggTime: tagAggTimeDefault,
    notificationText: '',
  },
  notificationInfo: {
    channels: [],
    priority: '',
  },
  formUtils: {
    reloadTagTable: false,
    isCustomExpValid: false,
    groupNameErrMsg: '',
  },
};

const tagTableInfo = {
  total: 0,
  isLoading: true,
  maxAGRAllowed: 0,
};

const tagFormFieldOptions = {
  keyOptions: [],
  valueOptionsObject: {},
  noOfGroupsToBeCreated: 0,
  channelOptions: [],
  isEditFormInit: false,
};

const tagFormStepLabels = () => [
  i18n.global.t('alert.tagGroupName'),
  i18n.global.t('alert.timeFrame'),
  i18n.global.t('alert.notification'),
];

const priorityList = () => [
  { name: i18n.global.t('alert.critical'), value: CRITICAL },
  { name: i18n.global.t('alert.warning'), value: WARNING },
  { name: i18n.global.t('alert.debug'), value: DEBUG },
  { name: i18n.global.t('alert.info'), value: INFO },
];

const groupAggregationTimeOptions = () => [
  { name: i18n.global.t('alert.minute', [1]), value: '60' },
  { name: i18n.global.t('alert.minutes', [2]), value: '120' },
  { name: i18n.global.t('alert.minutes', [3]), value: '180' },
  { name: i18n.global.t('alert.minutes', [4]), value: '240' },
  { name: i18n.global.t('alert.minutes', [5]), value: '300' },
];

const priorityEnum = {
  CRITICAL: 'Critical',
  WARNING: 'Warning',
  DEBUG: 'Debug',
  INFO: 'Info',
};

export {
  tagsTableHeaders,
  tagAggTimeDefault,
  tagFormDefaultData,
  tagTableInfo,
  tagFormFieldOptions,
  tagFormStepLabels,
  priorityList,
  groupAggregationTimeOptions,
  priorityEnum,
};
